import { Component } from "react";
import Layout from "../../component/layout";
import NextSeoModule from "../../component/next-seo";
import Fullstacktemplate from "../../component/course/full-stack-developer";
export default class Fullstackintrivandrum extends Component {
 
  render() {
   
    const title = "Full Stack Developer"  
    const url ="full-stack-developer"
     const url1 ="-training-in-trivandrum"
    const location = "trivandrum" 
    const location1="Training in Trivandrum"
    
     return(
      <>
          <NextSeoModule
          title={`${title} ${location1} - learnsoft.org`}
            description={`Become a Versatile Full Stack Developer with ${location1}. Learn to Build both Front-end and Back-end Components to Create Complete Web Applications.`}
            url={`${location}/${url}${url1}`}
            img={`course/${url}.webp`}
             keyword={`${title} training in ${location}, ${title} certification in ${location}, Online ${title}  Training in ${location}, ${title} Online Training in ${location}, ${title} Syllabus, ${title} course in ${location}, ${title} classes in ${location}, ${title} institute in ${location}, Best ${title} training institute in ${location}, ${title} training and certification in ${location}, Best ${title} training in ${location}, ${title} coaching in ${location}, ${title} training center in ${location}, ${title} training provider in ${location}`}
          />
        <Layout navbarBackgroundColor="#281E1E">
          <Fullstacktemplate url1={url1} title={title} url={url} relatedlocation={location} location={location} location1={location1} />
         
        </Layout>
      </>
    );
  }
}
